module.exports = __webpack_public_path__ + "static/img/recommend-list-10.9e5370f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/main/recommend-list-10.png
// module id = xxjW
// module chunks = 1